module.exports = __webpack_public_path__ + "static/media/banner.5421193e.png";